module.exports = __webpack_public_path__ + "img/rdsc_word.aa548a11.png";